import { render } from "./warning.vue?vue&type=template&id=35d0ca5f&scoped=true"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"

import "./warning.vue?vue&type=style&index=0&id=35d0ca5f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-35d0ca5f"

export default script